module.exports = __webpack_public_path__ + "img/circle-left-top.0e35a365.png";